// Display formatting helpers for the "Field Manual" UI.

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/** "Jun 18" */
export function shortDate(iso: string): string {
  const d = new Date(iso);
  return `${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

/** "Jun 18, 2026 · 6:42 PM" — for sealed-log headers. */
export function sealedDateTime(iso: string): string {
  const d = new Date(iso);
  let h = d.getHours();
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()} ${h}:${pad(d.getMinutes())} ${ampm}`;
}

/** 24-hour "9:18" clock stamp — for per-step check times. */
export function clockTime(iso: string): string {
  const d = new Date(iso);
  return `${d.getHours()}:${pad(d.getMinutes())}`;
}

/** "just now" / "22 min" / "3h ago" / "3d ago" / falls back to a date. */
export function timeAgo(iso: string, now: Date = new Date()): string {
  const diff = Math.max(0, now.getTime() - new Date(iso).getTime());
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  const w = Math.floor(d / 7);
  if (w < 5) return `${w}w ago`;
  return shortDate(iso);
}

/**
 * Local-part of an email ("ada@example.com" → "ada"), for display-name
 * fallbacks when a profile hasn't synced a display_name yet. Returns undefined
 * for a missing/empty address.
 */
export function emailLocalPart(email: string | null | undefined): string | undefined {
  return email?.split('@')[0] || undefined;
}

function pad(n: number): string {
  return String(n).padStart(2, '0');
}
